import { OrganizationSettings } from '@modules-deprecated/app/organization/types/organizationSettings'

export type FileType = 'attachment' | 'purchase' | 'voucher'

export const getFileType = (
  organizationSettings: OrganizationSettings | undefined,
  isAutoCegidIntegrationEnabled: boolean,
): FileType => {
  if (organizationSettings?.isInboxEnabled === '1') {
    return 'voucher'
  }
  if (isAutoCegidIntegrationEnabled) {
    return 'purchase'
  }
  return 'attachment'
}
